import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {BmDebtCollectionService} from "../../service/bm-debt-collection.service";
import {Contract} from "../../../payment-plan/model/contract.interface";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
    selector: 'bm-debt-collection',
    templateUrl: './bm-debt-collection.component.html',
    styleUrls: ['./bm-debt-collection.component.scss'],
    standalone: false,
})
export class BmDebtCollectionComponent implements OnInit, OnChanges, OnDestroy {

    @Input() dunningId: number;

    busy: boolean = false;
    initialized: boolean = false;
    error: string | null = null;
    private destroy$ = new Subject<void>();

    tabIndex: number = 0;
    selectedContract: Contract | null = null;

    constructor(protected debtCollectionService: BmDebtCollectionService) {
    }

    async ngOnInit(): Promise<void> {
        await this.initComponent();
    }

    /**
     * Initialize Component and load dunning data.
     */
    async initComponent(): Promise<void> {
        if (!this.dunningId) {
            this.error = 'No dunning ID provided';
            return;
        }

        this.busy = true;
        this.error = null;

        try {
            await this.debtCollectionService.initializeDebtCollection(this.dunningId);
            this.initialized = true;
        } catch (err) {
            this.error = 'Failed to load payment plan data';
            console.error('Error initializing payment plan:', err);
        } finally {
            this.busy = false;
        }

        this.subscribeToSelectedContract();
    }

    subscribeToSelectedContract(): void {
        this.debtCollectionService.selectedContract$
            .pipe(takeUntil(this.destroy$))
            .subscribe(contract => {
                this.selectedContract = contract;

                if (this.selectedContract) {
                    this.tabIndex = 1;
                }
            });
    }

    closeContractToolbar(): void {
        this.debtCollectionService.clearSelectedContract();
        this.selectedContract = null;
        this.tabIndex = 0;
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (changes['dunningId'] && changes['dunningId'].currentValue) {
            await this.initComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
